import type { TenantConfig } from "./tenants.config";

const STYLE_ID = "tenant-theme";
const FONT_LINK_ID = "tenant-font";

/**
 * Inject (or replace) a <style> tag on :root that overrides CSS variables
 * from the given tenant config. Also loads a custom font if specified.
 *
 * Must be called **before** the first React render so the initial paint
 * already uses the correct theme.
 */
export function applyTheme(config: TenantConfig): void {
  // --- CSS variable overrides ---
  const entries = Object.entries(config.theme);
  if (entries.length > 0) {
    const cssText = entries
      .map(([varName, value]) => `  ${varName}: ${value};`)
      .join("\n");
    const css = `:root {\n${cssText}\n}`;

    let style = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
    if (!style) {
      style = document.createElement("style");
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }
    style.textContent = css;
  }

  // --- Optional custom font ---
  if (config.fontUrl) {
    let link = document.getElementById(FONT_LINK_ID) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.id = FONT_LINK_ID;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    link.href = config.fontUrl;
  }
}
